import styled, { css } from "styled-components";


export const PaymentGatewayContainer = styled.div`
  padding-inline: 47px;
  padding-top: 35px;
`

export const PaymentGatewayHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const PaymentGatewayTitle = styled.div`
    font-weight: 700;
    font-size: 20px;
    color: #464e5f;
    margin: 0;
    font-family: var(--SettingsPaymentGatewayTitleFont-family);
    /* padding-top: 20px; */
`
export const PaymentGatewayActions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;


`

export const PaymentGatewayContent = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const PaymentGatewayContentName = styled.div`
  ${(props) => props.disabled && css`
    input {
      border: 1px solid rgb(181, 181, 195) !important;
      background-color: rgb(231, 231, 235) !important;
      pointer-events: none;
    }
  `}
`

export const PaymentGatewayContentAddName = styled.div`
  height: 48px;
  background-color: #F3F6F9;
  border-color: #F3F6F9;
  color: #3F4254;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  border-radius: 0.42rem;
  display: flex;
  align-items: center;
`
export const PaymentGatewayContentAddNameType = styled.div`
  padding-left: 1.5rem;
  font-size: 14px;
  color: #3F4254;
`
export const PaymentGatewayContentAddNameField = styled.input`
  background: transparent;
  border: none;
  color: #3F4254;
  height: 100%;
  flex: 1;
  padding-right: 1.5rem;
`





export const PaymentGatewayContentForm = styled.div`
  ${(props) => props.disabled && css`
    input {
      border: 1px solid rgb(181, 181, 195) !important;
      background-color: rgb(231, 231, 235) !important;
      pointer-events: none;
    }
  `}
`

